<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                信息审核
                <small>信息审核</small>
            </h1>
            <ol class="breadcrumb">
                <li>
                    <a href="#">
                        <i class="fa fa-dashboard"></i> 信息审核
                    </a>
                </li>
                <li class="active">信息审核</li>
            </ol>
        </section>
        <!-- Main content -->
        <section class="content">
            <!-- Main row -->
            <div class="row col-sm-12">
                <div id="atptoolbar">
                    <button class="btn btn-info" type="button" id="sys_detai" @click="review">
                        <i class="fa fa-sign-in"></i>&nbsp;审核
                    </button>
                </div>
                <table id="info_atptable"></table>
            </div>
        </section>
        <v-reviewStation :info-station="stationInfo" :info-add="addflag" ref="stationInfo"></v-reviewStation>
        <v-reviewAmmeter :info-ammeter="ammeterInfo" ref="ammeterInfo"></v-reviewAmmeter>
        <!-- /.content -->
    </div>
</template>
<script>
  // 审核基站
  import reviewStation from './reviewStation'
  // 审核电表
  import reviewAmmeter from './reviewAmmeter'

  export default {
    name: '',
    data () {
      return {
        stationInfo: {
          req_data: {}
        },
        ammeterInfo: {
          req_data: {}
        },
        addflag: false // 是否为新增基站 默认为false
      }
    },
    components: {
      'v-reviewStation': reviewStation,
      'v-reviewAmmeter': reviewAmmeter
    },
    mounted: function () {
      this.getInfoChange()
    },
    methods: {
      getInfoChange: function () {
        var self = this
        $('#info_atptable').bootstrapTable({
          url: self.global.apiHost + 'info_changes/',
          method: 'get', //请求方式（*）
          ajaxOptions: {
            headers: {
              'content-type': 'application/json', // 默认值
              Authorization: 'Bearer ' + localStorage.getItem('access_token')
            }
          },
          toolbar: '#atptoolbar', //工具按钮用哪个容器
          height: $(window).height() * 0.86,
          striped: true, //是否显示行间隔色
          cache: false, //是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
          pagination: true, //是否显示分页（*）
          iconSize: 'outline',
          sortable: true, //是否启用排序
          sortName: 'stst_atpid',
          sortOrder: 'DESC', //排序方式
          queryParams: self.queryParams, //传递参数（*）
          sidePagination: 'server', //分页方式：client客户端分页，server服务端分页（*）
          pageNumber: 1, //初始化加载第一页，默认第一页
          pageSize: 10, //每页的记录行数（*）
          pageList: [10], //可供选择的每页的行数（*）
          search: false, //是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
          showColumns: true, //是否显示所有的列
          showRefresh: true, //是否显示刷新按钮
          minimumCountColumns: 2, //最少允许的列数
          clickToSelect: true, //是否启用点击选中行
          singleSelect: true, // 是否启用单选
          uniqueId: 'id', //每一行的唯一标识，一般为主键列
          // responseHandler: function(res) {
          //   console.log("-------", res);
          //   // res.type  [10 新增基站 | 11 修改基站|20 新增电表|21 修改电表]
          //   return {
          //     total: res.length, //总页数
          //     rows: res.rows //数据
          //   };
          // },
          columns: [
            [
              { checkbox: true },
              {
                title: '序号',
                width: 40,
                formatter: function (value, row, index) {
                  return index + 1
                }
              },
              {
                title: '修改类型',
                width: 40,
                field: 'type',
                formatter: function (value, row, index) {
                  // [10 新增基站 | 11 修改基站|20 新增电表|21 修改电表]
                  // console.log(value);
                  var type = ''
                  switch (value) {
                    case 10:
                      type = '新增基站'
                      break
                    case 11:
                      type = '修改基站'
                      break
                    case 20:
                      type = '新增电表'
                      break
                    case 21:
                      type = '修改电表'
                      break
                    default:
                      break
                  }
                  return type
                }
              },
              {
                title: '发起人',
                width: 40,
                field: 'username'
              },
              {
                title: '基站名称',
                width: 40,
                field: 'stst_commname'
              },
              {
                title: '创建时间',
                width: 40,
                field: 'create_time',
                formatter: function (value, row, index) {
                  var time = value + '+0800'
                  var creat_time = new Date(time).toLocaleString('China', { hour12: false })
                  return creat_time
                }
              }
            ]
          ]
        })
      },
      queryParams: function (param) {
        param.org_id = JSON.parse(localStorage.getItem('companyInfo')).id
        param.per_page = param.limit
        param.page = param.offset / param.limit + 1
        return param
      },
      review: function () {
        var self = this
        var tableSelect = $('#info_atptable').bootstrapTable('getSelections')
        self.addflag = false
        if (tableSelect.length != 1) {
          alert('请先选中要操作的数据')
          // [10 新增基站 | 11 修改基站|20 新增电表|21 修改电表]  addflag
        } else if (tableSelect[0].type == 11) {
          typeof tableSelect[0].req_data == 'string'
            ? (tableSelect[0].req_data = JSON.parse(tableSelect[0].req_data))
            : (tableSelect[0].req_data = tableSelect[0].req_data)
          self.stationInfo = tableSelect[0]
          $('#sys_reviewstation_modal').modal('show')
          setTimeout(function () {
            self.$refs.stationInfo.loadData()
          }, 500)
        } else if (tableSelect[0].type == 10) {
          self.addflag = true
          typeof tableSelect[0].req_data == 'string'
            ? (tableSelect[0].req_data = JSON.parse(tableSelect[0].req_data))
            : (tableSelect[0].req_data = tableSelect[0].req_data)
          self.stationInfo = tableSelect[0]
          $('#sys_reviewstation_modal').modal('show')
          setTimeout(function () {
            self.$refs.stationInfo.loadData()
          }, 500)
        } else if (tableSelect[0].type == 20 || tableSelect[0].type == 21) {
          typeof tableSelect[0].req_data == 'string'
            ? (tableSelect[0].req_data = JSON.parse(tableSelect[0].req_data))
            : (tableSelect[0].req_data = tableSelect[0].req_data)
          self.ammeterInfo = tableSelect[0]
          $('#sys_reviewAmmeter_modal').modal('show')
          setTimeout(function () {
            self.$refs.ammeterInfo.loadData()
          }, 500)
        }
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/informationAudit/informationAudit.vue